/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { useState, useEffect } from 'react';
import { useAuth } from '@/context/authentication';
import { EarlyAccessService } from '@services/requests';

/**
 * Checks whether the current authenticated user has already submitted the
 * early-access form.  For unauthenticated visitors the result is always `false`
 * and no API call is made.
 */
export function useEarlyAccessStatus(): boolean {
  const { isAuthenticated } = useAuth();
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setCompleted(false);
      return;
    }
    EarlyAccessService.getEarlyAccess()
      .then(() => setCompleted(true))
      .catch(() => setCompleted(false));
  }, [isAuthenticated]);

  return completed;
}
